


/**
 * Takes and returns template string.
 * Used only for IDE extensions to provide css syntax features.
 */
export const css = (strings: TemplateStringsArray) => strings.raw[0]!;